import { StructuredTextFieldsFragment } from "../../../../../../graphql-types"
import React from "react"
import StructuredTextContent from "./structured-text-content"
import * as styles from "./structured-text-content-container.module.scss"


type StructuredTextContentContainerProps = {
  data: StructuredTextFieldsFragment
}

const StructuredTextContentContainer: React.FC<StructuredTextContentContainerProps> = ({ data }) => {
    return (
    <div className={styles.container}>
        <div className={styles.structuredText}>
            <StructuredTextContent data={data} />
      </div>
    </div>

  )
}

export default StructuredTextContentContainer
